<template>
  <div>
    <nav role="navigation" :aria-label="$t('pagination.navigation_label')" v-if="displayNextPage || displayPreviousPage">
      <div class="d-flex p-0 align-items-center justify-content-center" :key="resetPagination">
        <button v-if="displayPreviousPage" class="p-2 pagination-button cursor btn btn-link" 
                @click="pagination(currentPage-1)"
                :aria-label="$t('pagination.previous_page')">
          <i class="fa-solid fa-chevron-left"></i>
        </button>
        <button v-if="displayNextPage" class="p-2 pagination-button cursor btn btn-link" 
                @click="pagination(currentPage+1)"
                :aria-label="$t('pagination.next_page')">
          <i class="fa-solid fa-chevron-right"></i>
        </button>
        <p class="resultsTextPagination ml-3 mb-0">{{ $t('common.results_desc') + ' ' + firstIndex + ' ' + $t('common.to') + ' ' + lastResultIndex }}</p>
      </div>
    </nav>
  </div>
</template>


<script>
/** @author ARO - TLV 2020
 * @brief Component qui gère toutes les paginations sur DealPrudence
 * @param maxResultsByPage est le nombre de résultats maximum sur une page
 * @param firstIndex correspond à l'indice de la première demande de la page sélectionnée
 * @param nbResultsTotal correspond au total de résultats sur toutes les pages
 * @param refreshEvent correspond à l'événement du bus à appeler lors d'un passage à une autre page
 */
export default {
  name: 'PaginationTrackingCACP',
  props: ['maxResultsByPage', 'firstIndex', 'nbResultsTotal', 'refreshEvent', 'hasNext'],
  data () {
    return {
      nbPage: 1,
      newCurrentPage: 1,
      nextPageSearchInputSelected: false,
      previousPageSearchInputSelected: false,
      resetPagination: true,
      searchNextPageInput: '',
      searchPreviousPageInput: '',
      nbTotalPage : 1,
    }
  },
  methods: {
    pagination (nb) {
      this.nextPageSearchInputSelected = false
      this.previousPageSearchInputSelected = false
      if (nb === '') {
        //this.toggleNextPageSearchInput = !this.toggleNextPageSearchInput
        //this.togglePreviousPageSearchInput = !this.togglePreviousPageSearchInput
        this.resetPagination = !this.resetPagination
        return
      }
      let nbAsNumber = Math.floor(parseInt(nb)) //On converti nb en un nombre entier sans virgule pour vérifier si on lance ce qu'il y dans le if DRO 17/01/2024
      let allPagesArray = []
      if(this.nbTotalPage + 1 === nbAsNumber && this.hasNext)
          //Si on a une nouvelle page, on l'ajoute a l'index des pages
        this.nbTotalPage++;
      for(let i = 1; i <= this.nbTotalPage; i++) {
        allPagesArray.push(i)
      }
      if (allPagesArray.includes(nbAsNumber) && nbAsNumber !== this.currentPage) {
        if (this.searchNextPageInput !== '') { //Vérifie si la valeur est bien supérieure à la page actuelle pour le "..." allant vers l'avant
          if (nbAsNumber <= this.currentPage) {
            this.searchNextPageInput = ''
            return
          }
        }
        if (this.searchPreviousPageInput !== '') { //Vérifie si la valeur est bien inférieure à la page actuelle pour le "..." allant vers l'arrière
          if (nbAsNumber >= this.currentPage) {
            this.searchPreviousPageInput = ''
            return
          }
        }
        let newFirstIndex = (nbAsNumber - 1) * this.maxResultsByPage + 1
        this.nbPage = nbAsNumber
        this.$bus.$emit(this.refreshEvent, newFirstIndex)
      }
      this.searchNextPageInput = ''
      this.searchPreviousPageInput = ''
    }
  },
  /** @author TLV 02/04/2020
   * Remplacement du bus par des propriétés calculées pour gérer deux paginations sur une même page
   * (ce que ne permet pas vraiment le bus)
   * La page suivante est affichée si on n'est pas sur la dernière,
   * La page précédente est affichée sauf si on est sur la page 1 */
  computed: {
    displayLastPage () {
      return (this.currentPage + this.nextPages) < this.allPages
    },
    displayFirstPage () {
      return !this.previousPages.includes(1)
    },
    previousPages () {
      return Array.from(Array(this.currentPage).keys()).slice(Math.max(1, this.currentPage - 1))
    },
    nextPages () {
      return Math.min(1, this.allPages - this.currentPage)
    },
    /*
    allPages () {
      if (this.nbResultsTotal > this.maxResultsByPage) {
        return Math.floor(this.nbResultsTotal / this.maxResultsByPage) + ((this.nbResultsTotal % this.maxResultsByPage === 0) ? 0 : 1)
      } else if (Math.floor(this.nbResultsTotal / this.maxResultsByPage) + 1 === ((this.firstIndex - 1) / this.maxResultsByPage + 1)) {
        return 0
      } else {
        return this.currentPage
      }
    },*/
    currentPage: {
      get () {
        return (((this.firstIndex - 1) / this.maxResultsByPage) + 1)
      },
      set (newValue) {
        this.newCurrentPage = newValue
      }
    },
    /** @author ARO - TLV 2020
     * @brief Propriétée calculée qui vérifie si on affiche la page suivante ou non
     * @details Si le nombre de données affichées aux pages précédentes + le nombre
     *           max de données autorisées à être affichées sur cette page est
     *           toujours inférieur au nombre total de données retournées par la modé,
     *           alors on affiche le bouton pour passer à la page suivante
     */
    displayNextPage () {
      //Si pas a la derniere page OU Si derniere page et il peut y avoir de nouvelles pages
      return (this.nbPage < this.nbTotalPage) || (this.nbPage === this.nbTotalPage && this.hasNext)
      //return (this.firstIndex + this.maxResultsByPage - 1 < this.nbResultsTotal)
    },
    displayPreviousPage () {
      return (this.firstIndex !== 1)
    },
    lastResultIndex () {
      if (this.firstIndex + this.maxResultsByPage > this.nbResultsTotal) {
        return this.nbResultsTotal
      } else {
        return this.firstIndex + (this.maxResultsByPage - 1)
      }
    },
    setClassNextPageInput () {
      let classes = ''
      if (this.nextPageSearchInputSelected) {
        classes = 'border border-success rounded border-left mw-44px'
        return classes
      } else {
        return
      }
    },
    setClassPreviousPageInput () {
      let classes = ''
      if (this.previousPageSearchInputSelected) {
        classes = 'border border-success rounded border-left mw-44px'
        return classes
      } else {
        return
      }
    }
  }
}
</script>
